import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Form, Input, Select, Button, Icon, Modal, Row } from 'antd'
import { textInput, selectInput, inlineFormItem } from '../../EditSubStoDataPopup/edit-sub-sto.scss'

const { Item: FormItem } = Form
const DEFAULT_SEARCH_TYPE = 'id'
// ── constants ────────────────────────────────────────────────
const searchOptions = [
    { value: 'phone', label: 'טלפון', placeholder: 'הזן מספר טלפון', maxLength: 15 },
    { value: 'id', label: 'מזהה לקוח', placeholder: 'הזן מזהה לקוח', maxLength: 20 },
    { value: 'identity', label: 'ת״ז לקוח', placeholder: 'הזן תעודת זהות', maxLength: 9 }
]

const initialStatus = { success: true, message: '' }

const digitsOnly = e => e.target.value.replace(/[^\d]/g, '')

// ── component ────────────────────────────────────────────────
@observer
class SearchUserModal extends Component<any, any> {
    state = {
        loading: false,
        searchStatus: { ...initialStatus }
    }

    componentDidUpdate(prevProps) {
        if (this.props.visible && !prevProps.visible) {
            this.props.form.resetFields()
            this.setState({ loading: false, searchStatus: { ...initialStatus } })
        }
    }

    // ── handlers ─────────────────────────────────────────────
    handleDone = (success, message) => {
        this.setState({ loading: false, searchStatus: { success, message } })
        if (success) this.handleClose()
    }

    handleClose = () => {
        if (this.state.loading) return
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur()
        }
        this.props.form.resetFields()
        this.props.onClose()
    }

    handleSelectChange = () => {
        this.setState({ loading: false, searchStatus: { ...initialStatus } })
        this.props.form.resetFields(['search_value'])
    }

    handleSubmit = e => {
        e.preventDefault()
        this.props.form.validateFields((err, values) => {
            if (err) return

            const { onSearch } = this.props
            if (!onSearch) return

            this.setState({ loading: true }, () => {
                onSearch(values, this.handleDone)
            })
        })
    }

    // ── render ───────────────────────────────────────────────
    render() {
        const { getFieldDecorator, getFieldValue } = this.props.form
        const { visible, clientId, mainClose } = this.props
        const {
            loading,
            searchStatus: { message }
        } = this.state

        const searchType = getFieldValue('search_type') || DEFAULT_SEARCH_TYPE
        const currentOption = searchOptions.find(opt => opt.value === searchType) || searchOptions[0]

        return (
            <Modal
                width={420}
                visible={visible}
                onCancel={() => (!clientId ? mainClose() : this.handleClose())}
                maskClosable={false}
                title="חיפוש לקוח"
                footer={message ? <>{message}</> : null}
                destroyOnClose
            >
                <Form onSubmit={this.handleSubmit} layout="inline">
                    <Row gutter={8} type="flex" align="middle" justify="center" style={{ width: '100%' }}>
                        <FormItem className={inlineFormItem} style={{ width: '40%', margin: 'unset' }}>
                            {getFieldDecorator('search_type', { initialValue: 'id' })(
                                <Select
                                    className={selectInput}
                                    style={{ width: '100%' }}
                                    onChange={this.handleSelectChange}
                                >
                                    {searchOptions.map(opt => (
                                        <Select.Option key={opt.value} value={opt.value}>
                                            {opt.label}
                                        </Select.Option>
                                    ))}
                                </Select>
                            )}
                        </FormItem>

                        <FormItem className={inlineFormItem} style={{ width: '50%', margin: 'unset' }}>
                            {getFieldDecorator('search_value', {
                                rules: [{ required: true, message: `יש להזין ` + currentOption.label }],
                                getValueFromEvent: digitsOnly
                            })(
                                <Input
                                    className={textInput}
                                    placeholder={currentOption.placeholder}
                                    maxLength={currentOption.maxLength}
                                    style={{ width: '100%' }}
                                />
                            )}
                        </FormItem>

                        <FormItem className={inlineFormItem} style={{ width: '10%', margin: 'unset' }}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                disabled={loading}
                                style={{ width: '100%', margin: 'unset', padding: 'unset' }}
                            >
                                <Icon type={loading ? 'loading' : 'search'} />
                            </Button>
                        </FormItem>
                    </Row>
                </Form>
            </Modal>
        )
    }
}

export default Form.create()(SearchUserModal)
